import 'parsleyjs';

$('.registration-form').parsley();
